exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1c7iJ{position:relative;z-index:50;width:100%;height:100%}.T7_S2{position:relative}.luLIo{height:0;width:0;visibility:hidden}\n", ""]);

// Exports
exports.locals = {
	"playerContainer": "_1c7iJ",
	"mainContainer": "T7_S2",
	"mockedVideo": "luLIo"
};